<div *ngIf="isLoading">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <div *ngIf="percentage">
    <mat-spinner class="spinner-center" style="z-index: 1000;" aria-label="Rating">
    </mat-spinner>
    <div class="spinner-center" style="z-index: 1000; font-size: x-large;">{{ percentage | number : '1.0-1' }} %</div>
  </div>
  <mat-spinner *ngIf="!percentage" class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>


<div mat-dialog-title>
  {{ modalData.title }}
  <div style="float: right; margin-top: -5px;">
    <button mat-icon-button *ngIf="modalData.isEdit">
      <img src="../../../../assets/delete.png" style="width: 20px;" (click)="delete(modalData.topicId, type)">
    </button>
    <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()">
      <img src="../../../../assets/close-white.png" style="width: 12px;">
    </button>
  </div>
</div>

<mat-dialog-content *ngIf="!modalData.isEdit" class="mat-typography">
  <div class="form-group row">
    <label class="col-3 col-form-label">ชื่อคอร์ส</label>
    <div class="col-9 col-form-label" id="courseName">
      {{ modalData.courseName }}
    </div>
  </div>

  <div class="form-group row">
    <label class="col-3 col-form-label">ชื่อบทเรียน</label>
    <span class="col-9 col-form-label" id="lessonName">
      {{ modalData.value.LESSON_NAME ? modalData.value.LESSON_NAME : modalData.lessonName }}
    </span>
  </div>

  <div class="form-group row">
    <label class="col-3 col-form-label">ประเภท<lifedi-require></lifedi-require></label>
    <div class="col-9">
      <select class="custom-select form-control" style="display: inline;" (change)="setType($event)">
        <option selected disabled hidden>เลือกประเภท</option>
        <option *ngFor="let t of topicType" [value]="t.name" [selected]="type === t.name">{{ t.name }}
        </option>
      </select>
    </div>
  </div>

  <form [formGroup]="videoForm" class="mt-1">
    <div *ngIf="type === 'Video'" class="container topicBox">
      <div class="form-group row" style="margin-top: 35px;">
        <label for="name" class="col-4 col-form-label">ชื่อหัวข้อ<lifedi-require></lifedi-require></label>
        <div class="col-8">
          <input type="text" class="form-control" id="name" formControlName="name" autocomplete="off" ngDefaultControl>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-4 col-form-label">อัปโหลดสื่อ<lifedi-require></lifedi-require></label>
        <div class="col-8">
          <div class="custom-file">
            <input type="file" class="custom-file-input" id="uploadVDO" accept="video/mp4, video/x-m4v, video/*"
              (change)="selectVDO($event, videoForm)">
            <label *ngIf="!originalNameVdo" class="custom-file-label" for="uploadVDO">Choose file</label>
            <label *ngIf="originalNameVdo" class="custom-file-label" for="uploadVDO">{{ originalNameVdo }}</label>
          </div>
        </div>
      </div>
      <!-- <div class="form-group row">
        <label class="col-4 col-form-label">อัปโหลดภาพปก VDO <small class="text-danger">(ถ้ามี)</small></label>
        <div class="col-8">
          <div class="custom-file">
            <input type="file" class="custom-file-input" id="vdoThumnal" accept=".png, .jpg, .jpeg"
              (change)="selectVdoCover($event, videoForm)">
            <label *ngIf="!vdoThumnal" class="custom-file-label" for="vdoThumnal">Choose file</label>
            <label *ngIf="vdoThumnal" class="custom-file-label" for="vdoThumnal">{{ vdoThumnal }}</label>
          </div>
        </div>
      </div> -->
      <div class="row justify-content-center">
        <small class="text-danger">ขนาดไฟล์ VDO ไม่ควรเกิน 1 GB</small>
      </div>
    </div>
  </form>



  <form [formGroup]="quizForm" class="mt-1">
    <div *ngIf="type === 'Quiz'" class="container topicBox">
      <div class="form-group row" style="margin-top: 35px;">
        <label for="name" class="col-4 col-form-label">ชื่อ Quiz<lifedi-require></lifedi-require></label>
        <div class="col-8">
          <input type="text" class="form-control" id="name" formControlName="name" autocomplete="off" ngDefaultControl>
        </div>
      </div>
      <div class="form-group row">
        <label for="timeQuizAgain" class="col-4 col-form-label">ระยะเวลาในการทำได้อีกครั้ง<lifedi-require>
          </lifedi-require></label>
        <div class="col-7">
          <input type="number" class="form-control" id="timeQuizAgain" formControlName="timeQuizAgain"
            autocomplete="off" min="0" step="1" ngDefaultControl>
        </div>
        <div class="col-form-label">
          วัน
        </div>
      </div>
      <div class="form-group row">
        <label for="passOfQuiz" class="col-4 col-form-label">คะแนนผ่านเกณฑ์<lifedi-require></lifedi-require></label>
        <div class="col-8">
          <input type="number" class="form-control" id="passOfQuiz" formControlName="passOfQuiz" autocomplete="off"
            min="0" step="1" ngDefaultControl>
        </div>
      </div>
      <div *ngFor="let q of quizForm.get('quizArray')['controls']; let i = index" formArrayName="quizArray"
        class="mb-3">
        <div [formGroupName]="i" class="quizBox pt-4 pb-3">
          <div>
            <button mat-mini-fab class="img close-btn" (click)="removeGroup(true, i)"
              [style.backgroundImage]="'url(\'../../../../assets/close.png\')'"></button>
          </div>
          <div class="form-group row mt-3">
            <label class="col-2 col-form-label">Q{{ i + 1 }}<lifedi-require></lifedi-require></label>
            <div class="col-10">
              <textarea formControlName="QUESTION" class="form-control" cols="35" rows="2"></textarea>
            </div>
          </div>
          <div *ngFor="let c of q.get('OPTIONS')['controls']; let j = index" formArrayName="OPTIONS" class="mt-3">
            <div class="form-group row" [formGroupName]="j">
              <!-- ใช้เก็บ OPTION_NUMBER ไม่ได้ใช้งาน -->
              <input type="text" formControlName="OPTION_NUMBER" autocomplete="off" [ngModel]="j+1" readonly
                style="display: none;" ngDefaultControl>

              <label class="col-2 col-form-label">C{{ j + 1 }}<lifedi-require></lifedi-require></label>
              <div class="col-7">
                <input type="text" class="form-control" formControlName="OPTION_NAME" autocomplete="off"
                  ngDefaultControl>
              </div>
              <div class="col-1">
                <button mat-mini-fab class="img" (click)="fileInput.click()" style="border-radius: 0; box-shadow: none;"
                  [style.backgroundImage]="'url(\' ../../../../assets/picture.png\')'">
                  <input #fileInput type="file" accept=".png, .jpg, .jpeg" (change)="addPic($event, c)"
                    style="display:none;" />
                </button>
              </div>
              <div class="col-2">
                <button mat-mini-fab class="img" (click)="removeChoice(true, i, j)"
                  [style.backgroundImage]="'url(\'../../../../assets/remove.png\')'"></button>
              </div>
              <div class="offset-2 col-10">{{ c.value.OPTION_IMAGENAME }}</div>
            </div>
          </div>
          <div class="row justify-content-center mb-3">
            <button mat-mini-fab class="img" (click)="addChoice(true, i)"
              [style.backgroundImage]="'url(https://lifedi2021-production.s3.ap-southeast-1.amazonaws.com/measure/add.png)'">
            </button>
          </div>

          <div class="form-group row justify-content-center">
            <label class=" col-3 col-form-label">คำตอบ<lifedi-require></lifedi-require></label>
            <div class="col-7">
              <select class="custom-select form-control" style="display: inline;" formControlName="ANSWER_NUMBER">
                <option value="" selected disabled hidden>เลือกคำตอบ</option>
                <option *ngFor="let c of q.get('OPTIONS')['controls']; let j = index" [value]="j+1">
                  C{{ j+1 }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <lifedi-btn lable="เพิ่มคำถาม" (click)="addGroup(true, quizForm.get('quizArray')['controls'].length)"
          customStyle="background-color: #00b181; color: #FFF; margin: 0px; padding: 0 30px;">
        </lifedi-btn>
      </div>
    </div>
  </form>



  <form [formGroup]="assignmentForm" class="mt-1">
    <div *ngIf="type === 'Assignment'" class="container topicBox">
      <div class="form-group row" style="margin-top: 35px;">
        <label for="name" class="col-3 col-form-label">ชื่อ Assignment<lifedi-require></lifedi-require></label>
        <div class="col-9">
          <input type="text" class="form-control" id="name" formControlName="name" autocomplete="off" ngDefaultControl>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-3 col-form-label">อัปโหลดไฟล์<lifedi-require></lifedi-require></label>
        <div class="col-9">
          <div class="custom-file">
            <input type="file" class="custom-file-input" id="assignmentDoc"
              accept=".pdf, application/pdf, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              (change)="selectAssignment($event, assignmentForm)">
            <label *ngIf="!assignmentDoc" class="custom-file-label" for="assignmentDoc">Choose file</label>
            <label *ngIf="assignmentDoc" class="custom-file-label" for="assignmentDoc">{{ assignmentDoc }}</label>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="timeShow" class="col-3 col-form-label">เวลาแสดง<lifedi-require></lifedi-require></label>
        <div class="col-8">
          <input type="number" class="form-control" id="timeShow" formControlName="timeShow" autocomplete="off" min="0"
            step="1" ngDefaultControl>
        </div>
        <div class="col-form-label">
          วัน
        </div>
      </div>
    </div>
  </form>


  <form [formGroup]="measureForm" class="mt-1">
    <div *ngIf="type === 'Measure'" class="container topicBox">
      <div class="form-group row" style="margin-top: 35px;">
        <label for="measureTest" class="col-3 col-form-label">แบบทดสอบ<lifedi-require></lifedi-require></label>
        <div class="col-9">
          <select class="custom-select form-control" style="display: inline;" formControlName="measureId"
            (change)="log()">
            <option selected disabled hidden>เลือกประเภท</option>
            <option *ngFor="let m of allMeasure" [value]="m.MEASURE_ID">{{ m.MEASURE_NAME }}</option>
          </select>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>





<mat-dialog-content *ngIf="modalData.isEdit" class="mat-typography">
  <div class="form-group row">
    <label class="col-3 col-form-label">ชื่อคอร์ส</label>
    <div class="col-9 col-form-label" id="courseName">
      {{ modalData.courseName }}
    </div>
  </div>

  <div class="form-group row">
    <label class="col-3 col-form-label">ชื่อบทเรียน</label>
    <span class="col-9 col-form-label" id="lessonName">
      {{ modalData.lessonName }}
    </span>
  </div>

  <div class="form-group row">
    <label class="col-3 col-form-label">ประเภท<lifedi-require></lifedi-require></label>
    <div class="col-9">
      <select class="custom-select form-control" style="display: inline;" (change)="setType($event)" [(ngModel)]="type">
        <option *ngFor="let t of topicType" id="video" [value]="t.name">{{ t.name }}</option>
      </select>
    </div>
  </div>

  <form [formGroup]="videoForm" class="mt-1">
    <div *ngIf="type === 'Video'" class="container topicBox">
      <div class="form-group row" style="margin-top: 35px;">
        <label for="name" class="col-4 col-form-label">ชื่อหัวข้อ<lifedi-require></lifedi-require></label>
        <div class="col-8">
          <input type="text" class="form-control" id="name" formControlName="name" autocomplete="off" ngDefaultControl>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-4 col-form-label">อัปโหลดสื่อ<lifedi-require></lifedi-require></label>
        <div class="col-8">
          <div class="custom-file">
            <input type="file" class="custom-file-input" id="uploadVDO" accept="video/mp4, video/x-m4v, video/*"
              (change)="selectVDO($event, videoForm)">
            <label *ngIf="!originalNameVdo" class="custom-file-label" for="uploadVDO">Choose file</label>
            <label *ngIf="originalNameVdo" class="custom-file-label" for="uploadVDO">{{ originalNameVdo }}</label>
          </div>
        </div>
      </div>
      <!-- <div class="form-group row">
        <label class="col-4 col-form-label">อัปโหลดภาพปก VDO <small class="text-danger">(ถ้ามี)</small></label>
        <div class="col-8">
          <div class="custom-file">
            <input type="file" class="custom-file-input" id="vdoThumnal" accept=".png, .jpg, .jpeg"
              (change)="selectVdoCover($event, videoForm)">
            <label *ngIf="!vdoThumnal" class="custom-file-label" for="vdoThumnal">Choose file</label>
            <label *ngIf="vdoThumnal" class="custom-file-label" for="vdoThumnal">{{ vdoThumnal }}</label>
          </div>
        </div>
      </div> -->
      <div class="row justify-content-center">
        <small class="text-danger">ขนาดไฟล์ VDO ไม่ควรเกิน 1 GB</small>
      </div>
    </div>
  </form>



  <form [formGroup]="quizForm" class="mt-1">
    <div *ngIf="type === 'Quiz'" class="container topicBox">
      <div class="form-group row" style="margin-top: 35px;">
        <label for="name" class="col-4 col-form-label">ชื่อ Quiz<lifedi-require></lifedi-require></label>
        <div class="col-8">
          <input type="text" class="form-control" id="name" formControlName="name" autocomplete="off" ngDefaultControl>
        </div>
      </div>
      <div class="form-group row">
        <label for="timeQuizAgain" class="col-4 col-form-label">
          ระยะเวลาในการทำได้อีกครั้ง<lifedi-require></lifedi-require>
        </label>
        <div class="col-7">
          <input type="number" class="form-control" id="timeQuizAgain" formControlName="timeQuizAgain"
            autocomplete="off" min="0" step="1" ngDefaultControl>
        </div>
        <div class="col-form-label">
          วัน
        </div>
      </div>
      <div class="form-group row">
        <label for="passOfQuiz" class="col-4 col-form-label">คะแนนผ่านเกณฑ์<lifedi-require></lifedi-require></label>
        <div class="col-8">
          <input type="number" class="form-control" id="passOfQuiz" formControlName="passOfQuiz" autocomplete="off"
            min="0" step="1" ngDefaultControl>
        </div>
      </div>
      <div *ngFor="let q of quizForm.get('quizArray')['controls']; let i = index" formArrayName="quizArray"
        class="mb-3">
        <div [formGroupName]="i" class="quizBox pt-4 pb-3">
          <div>
            <button mat-mini-fab class="img close-btn" (click)="removeGroup(true, i)"
              [style.backgroundImage]="'url(\'../../../../assets/close.png\')'"></button>
          </div>
          <div class="form-group row mt-3">
            <label class="col-2 col-form-label">Q{{ i + 1 }}<lifedi-require></lifedi-require></label>
            <div class="col-10">
              <textarea formControlName="QUESTION" class="form-control" cols="35" rows="2"></textarea>
            </div>
          </div>
          <div *ngFor="let c of q.get('OPTIONS')['controls']; let j = index" formArrayName="OPTIONS" class="mt-3">
            <div class="form-group row" [formGroupName]="j">
              <!-- ใช้เก็บ OPTION_NUMBER ไม่ได้ใช้งาน -->
              <input type="text" formControlName="OPTION_NUMBER" autocomplete="off" [ngModel]="j+1" readonly
                style="display: none;" ngDefaultControl>

              <label class="col-2 col-form-label">C{{ j + 1 }}<lifedi-require></lifedi-require></label>
              <div class="col-7">
                <input type="text" class="form-control" formControlName="OPTION_NAME" autocomplete="off"
                  (change)="updateQuizArrayForm()">
              </div>
              <div class="col-1">
                <button mat-mini-fab class="img" (click)="fileInput.click()" style="border-radius: 0; box-shadow: none;"
                  [style.backgroundImage]="'url(\' ../../../../assets/picture.png\')'">
                  <input #fileInput type="file" accept=".png, .jpg, .jpeg" (change)="addPic($event, c)"
                    style="display:none;" />
                </button>
              </div>
              <div class="col-2">
                <button mat-mini-fab class="img" (click)="removeChoice(true, i, j)"
                  [style.backgroundImage]="'url(\'../../../../assets/remove.png\')'"></button>
              </div>
              <div class="offset-2 col-10">{{ c.value.OPTION_IMAGENAME }}</div>
            </div>
          </div>
          <div class="row justify-content-center mb-3">
            <button mat-mini-fab class="img" (click)="addChoice(true, i)"
              [style.backgroundImage]="'url(https://lifedi2021-production.s3.ap-southeast-1.amazonaws.com/measure/add.png)'">
            </button>
          </div>

          <div class="form-group row justify-content-center">
            <label class=" col-3 col-form-label">คำตอบ<lifedi-require></lifedi-require></label>
            <div class="col-7">
              <select class="custom-select form-control" style="display: inline;" formControlName="ANSWER_NUMBER"
                (change)="updateQuizArrayForm()">
                <option value="" selected disabled hidden>เลือกคำตอบ</option>
                <option *ngFor="let c of q.get('OPTIONS')['controls']; let j = index" [value]="j+1">
                  C{{ j+1 }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <lifedi-btn lable="เพิ่มคำถาม" (click)="addGroup(true, quizForm.get('quizArray')['controls'].length)"
          customStyle="background-color: #00b181; color: #FFF; margin: 0px; padding: 0 30px;">
        </lifedi-btn>
      </div>
    </div>
  </form>



  <form [formGroup]="assignmentForm" class="mt-1">
    <div *ngIf="type === 'Assignment'" class="container topicBox">
      <div class="form-group row" style="margin-top: 35px;">
        <label for="name" class="col-3 col-form-label">ชื่อ Assignment<lifedi-require></lifedi-require></label>
        <div class="col-9">
          <input type="text" class="form-control" id="name" formControlName="name" autocomplete="off" ngDefaultControl>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-3 col-form-label">อัปโหลดไฟล์<lifedi-require></lifedi-require></label>
        <div [ngClass]="assignmentLink !== null ? 'col-7' : 'col-9'">
          <div class="custom-file">
            <input type="file" class="custom-file-input" id="assignmentDoc"
              accept=".pdf, application/pdf, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              (change)="selectAssignment($event, assignmentForm)">
            <label *ngIf="!assignmentDoc" class="custom-file-label" for="assignmentDoc">Choose file</label>
            <label *ngIf="assignmentDoc" class="custom-file-label" for="assignmentDoc">{{ assignmentDoc }}</label>
          </div>
        </div>
        <div *ngIf="assignmentLink" [ngClass]="assignmentLink !== null ? 'col-1 col-form-label' : ''">
          <a [href]="assignmentLink" target="_blank" style="cursor: pointer;">
            <img src="../../../../assets/document.png" style="width: 20px;">
          </a>
        </div>
      </div>
      <div class="form-group row">
        <label for="timeShow" class="col-3 col-form-label">เวลาแสดง<lifedi-require></lifedi-require></label>
        <div class="col-8">
          <input type="number" class="form-control" id="timeShow" formControlName="timeShow" autocomplete="off" min="0"
            step="1" ngDefaultControl>
        </div>
        <div class="col-form-label">
          วัน
        </div>
      </div>
    </div>
  </form>


  <form [formGroup]="measureForm" class="mt-1">
    <div *ngIf="type === 'Measure'" class="container topicBox">
      <div class="form-group row" style="margin-top: 35px;">
        <label for="measureTest" class="col-3 col-form-label">แบบทดสอบ<lifedi-require></lifedi-require></label>
        <div class="col-9">
          <select class="custom-select form-control" style="display: inline;" formControlName="measureId"
            (change)="log()">
            <option selected disabled hidden>เลือกประเภท</option>
            <option *ngFor="let m of allMeasure" [value]="m.MEASURE_ID">{{ m.MEASURE_NAME }}</option>
          </select>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>

<div *ngIf="!modalData.isEdit" align="center" style="padding-bottom: 20px; margin-right: 10px;">
  <button *ngIf="videoForm.valid" mat-button style="background: #3E8C1A; color: #fff;"
    (click)="addTopic(videoForm.value, false)">
    {{ modalData.actionBtnText }}
  </button>
  <button *ngIf="quizForm.valid" mat-button style="background: #3E8C1A; color: #fff;"
    (click)="addTopic(quizForm.value, false)">
    {{ modalData.actionBtnText }}
  </button>
  <button *ngIf="assignmentForm.valid" mat-button style="background: #3E8C1A; color: #fff;"
    (click)="addTopic(assignmentForm.value, false)">
    {{ modalData.actionBtnText }}
  </button>
  <button *ngIf="measureForm.valid" mat-button style="background: #3E8C1A; color: #fff;"
    (click)="addTopic(measureForm.value, false)">
    {{ modalData.actionBtnText }}
  </button>
  <button *ngIf="!videoForm.valid && !quizForm.valid && !assignmentForm.valid && !measureForm.valid" mat-button
    disabled="true">
    {{ modalData.actionBtnText }}
  </button>
</div>

<div *ngIf="modalData.isEdit" align="center" style="padding-bottom: 20px; margin-right: 10px;">
  <button *ngIf="videoForm.valid" mat-button style="background: #3E8C1A; color: #fff;"
    (click)="addTopic(videoForm.value, true)">
    {{ modalData.actionBtnText }}
  </button>
  <button *ngIf="quizForm.valid" mat-button style="background: #3E8C1A; color: #fff;"
    (click)="addTopic(quizForm.get('quizArray')['controls'], true)">
    {{ modalData.actionBtnText }}
  </button>
  <button *ngIf="assignmentForm.valid" mat-button style="background: #3E8C1A; color: #fff;"
    (click)="addTopic(assignmentForm.value, true)">
    {{ modalData.actionBtnText }}
  </button>
  <button *ngIf="measureForm.valid" mat-button style="background: #3E8C1A; color: #fff;"
    (click)="addTopic(measureForm.value, true)">
    {{ modalData.actionBtnText }}
  </button>
  <button *ngIf="!videoForm.valid && !quizForm.valid && !assignmentForm.valid && !measureForm.valid" mat-button
    disabled="true">
    {{ modalData.actionBtnText }}
  </button>
</div>
